import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ArrowLeft } from 'lucide-react';
import { safeAnchorHref } from '../../../lib/link';
import { cn } from '../../../lib/utils';
import { specraFocusRing } from '../ensigns/focus-ring';
/** Back affordance at the top of a record sidebar ("← All pursuits"). */ export function SpecraSidebarBackLink({ className, collapsed = false, href, icon, label, renderLink, testId, ...rest }) {
    const anchorProps = {
        ...rest,
        'aria-label': collapsed ? label : undefined,
        'data-testid': testId,
        title: label,
        className: cn('flex w-full items-center gap-[var(--space-2)] rounded-[var(--radius-md)] px-[var(--space-2)] py-[var(--space-1)] text-[length:var(--fs-ui-body)] text-muted-foreground transition-colors hover:bg-accent/70 hover:text-foreground', collapsed && 'justify-center', specraFocusRing, className)
    };
    const children = /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("span", {
                "aria-hidden": "true",
                className: "flex shrink-0 items-center [&_svg]:size-3.5",
                children: icon ?? /*#__PURE__*/ _jsx(ArrowLeft, {})
            }),
            collapsed ? null : /*#__PURE__*/ _jsx("span", {
                className: "min-w-0 truncate",
                children: label
            })
        ]
    });
    // Sanitise once for both paths, so a host renderer never receives an
    // executable scheme either; a rejected href renders a non-navigating anchor.
    const safeHref = safeAnchorHref(href);
    if (renderLink && safeHref) {
        return renderLink({
            ...anchorProps,
            children,
            href: safeHref
        });
    }
    return /*#__PURE__*/ _jsx("a", {
        ...anchorProps,
        href: safeHref,
        children: children
    });
}
